export type NotificationTypeLabelKey =
  | "promotions"
  | "payments"
  | "system"
  | "kyc"
  | "fallback"

export function notificationTypeLabelKey(
  type: string
): NotificationTypeLabelKey {
  if (type === "promotions") return "promotions"
  if (type === "transactional" || type === "transactional-warning")
    return "payments"
  if (type === "system" || type === "system-alert") return "system"
  if (type === "kyc") return "kyc"
  return "fallback"
}
